import { useRef } from 'react';
import { usePageContext } from '../../../../context.js';
import { useTaskContext } from '../../context.js';
import { useMatchTaskBreakpoint, taskBreakpoints } from '../../hook.task-breakpoints.js';
import { RetryButton } from './atom.retry-button.js';
import { StartCommaInput } from './atom.start-comma.js';
import { Input } from './input.js';
import { ReadonlyInput } from './input.readonly.js';
import { root, wrapper, container, header, heading } from './organism.input-container.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function InputContainer(props) {
  const pageContext = usePageContext();
  const context = useTaskContext();
  const isMobile = useMatchTaskBreakpoint(taskBreakpoints.mobile);
  const inputRef = useRef(null);
  const input = props.task.content[0];
  if (!input) {
    return null;
  }
  return /*#__PURE__*/jsxs("div", {
    className: root,
    "data-context": context,
    "data-page-context": pageContext,
    children: [/*#__PURE__*/jsxs("div", {
      className: wrapper,
      children: [/*#__PURE__*/jsxs("div", {
        className: container,
        children: [/*#__PURE__*/jsxs("div", {
          className: header,
          children: [/*#__PURE__*/jsx("span", {
            className: heading,
            children: "Din tekst"
          }), input && "withStartComma" in input.validation && /*#__PURE__*/jsx(StartCommaInput, {
            taskEntryKey: props.taskEntryKey,
            input: input
          })]
        }), /*#__PURE__*/jsx(Input, {
          ref: inputRef,
          taskEntryKey: props.taskEntryKey,
          input: input
        }), isMobile && /*#__PURE__*/jsx(RetryButton, {
          taskEntryKey: props.taskEntryKey,
          input: input,
          inputRef: inputRef
        })]
      }), pageContext !== "print" && /*#__PURE__*/jsxs("div", {
        className: container,
        children: [/*#__PURE__*/jsx("div", {
          className: header,
          children: /*#__PURE__*/jsx("span", {
            className: heading,
            children: "Original tekst"
          })
        }), /*#__PURE__*/jsx(ReadonlyInput, {
          text: input.initialText ?? ""
        })]
      })]
    }), pageContext !== "print" && !isMobile && /*#__PURE__*/jsx(RetryButton, {
      taskEntryKey: props.taskEntryKey,
      input: input,
      inputRef: inputRef
    })]
  });
}

export { InputContainer };
//# sourceMappingURL=organism.input-container.js.map
